import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { numberWithCommas } from '../../../Constants/HomePage';
import { getViewsText } from '../../../Utils/ContentUtils';
import { getFirebaseLiveData } from '../../../Utils/firebaseLiveData';
import { isIOSAppUser, removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';

import { Content, VideoTitle, Views } from '../ArticlesAndVideos/styled';
import { getSearchParams } from '../common';
import {
  RecentArticleCardStyle,
  RecentArticleImage,
  RecentDescriptionContainer,
} from './styled';

export default function RecentArticleCard(props) {
  const {
    cardData,
    searchArticle,
    primaryTagId,
    readMoreMylo,
    babyNamesArticle,
    id,
    articleId = true,
    allData,
    lang,
  } = props;
  const router = useRouter();
  const [cardEffect, setCardEffect] = useState(' ');
  const [viewsData, setViewsData] = useState({});
  const viewsValueData = async () => {
    const { getValues } = getFirebaseLiveData();
    const updatedData = await getValues('Views/OwnArticle/', cardData?.id);
    setViewsData(updatedData);
  };
  const ArticleImage =
    cardData?.webpImages?.[0] ||
    cardData?.multiImage?.[0]?.url ||
    allData?.imageUrl ||
    cardData?.files?.[0]?.imageUrl;
  const getTagData = () => {
    let data = '';
    const tagsWithId = cardData?.tagsWithId;
    const primary_tag_id = primaryTagId;
    tagsWithId?.map((element) => {
      if (element?.term_id == primary_tag_id) {
        data = element?.description;
      }
    });
    if (!data) {
      data = cardData?.tagsWithId?.[0]?.description;
    }
    return data;
  };
  useEffect(() => {
    if (cardData?.id) setViewsData(viewsValueData());
  }, [cardData]);
  useEffect(() => {
    setCardEffect('');
  }, []);

  return (
    <Link
      href={{
        pathname: !isIOSAppUser() && cardData?.web_url,
        query: removeDefaultParams(router.query),
      }}
      passHref
      key={id}
      locale={false}
      legacyBehavior
    >
      <RecentArticleCardStyle
        readMoreMylo={readMoreMylo}
        babyNamesArticle={babyNamesArticle}
        id={id}
        searchArticle={searchArticle}
        className={cardEffect}
        onClick={(e) => {
          e.preventDefault();
          setCardEffect('lowOpacity');
          setTimeout(() => {
            if (!isIOSAppUser())
              router.push(cardData?.web_url + getSearchParams(), '', {
                locale: getRouterLocale(router),
              });
          }, [200]);
        }}
        as="a"
      >
        <div>
          <RecentArticleImage
            src={ArticleImage}
            srcSet={
              ArticleImage
                ? `${ArticleImage}?tr=w-140,q-90 140w, ${ArticleImage}?tr=w-400,q-90 400w`
                : null
            }
            sizes={ArticleImage ? '(max-width: 720px) 140px, 400px' : null}
            alt={`Image related to ${getTagData()}`}
            width="100%"
            loading="lazy"
          />
        </div>
        <RecentDescriptionContainer>
          <VideoTitle>{getTagData()}</VideoTitle>
          <Content>{cardData?.title}</Content>

          <Views>
            {viewsData?.views ? (
              <>
                ({numberWithCommas(viewsData?.views)} {getViewsText(lang)})
              </>
            ) : null}
          </Views>
        </RecentDescriptionContainer>
      </RecentArticleCardStyle>
    </Link>
  );
}
